import { SET_CONTAINS_XSS_INPUT } from 'actions';

export function setContainsXssInput(containsXssInput: boolean) {
  return { containsXssInput, type: SET_CONTAINS_XSS_INPUT };
}
